import { defineAction } from '@cheesecakelabs/boilerplate/utils'

import * as captureItemsService from '_services/capture-items'

export const CREATE_CAPTURE_ITEM = defineAction('CREATE_CAPTURE_ITEM')
export const GET_CAPTURE_ITEMS = defineAction('GET_CAPTURE_ITEMS')
export const UPDATE_CAPTURE_ITEM = defineAction('UPDATE_CAPTURE_ITEM')
export const UPDATE_CAPTURE_ITEM_DATE = defineAction('UPDATE_CAPTURE_ITEM_DATE')
export const UPDATE_CAPTURE_ITEM_STATUS = defineAction('UPDATE_CAPTURE_ITEM_STATUS')
export const SET_CAPTURE_ITEMS_ORDER = defineAction('SET_CAPTURE_ITEMS_ORDER')
export const DELETE_CAPTURE_ITEM = defineAction('DELETE_CAPTURE_ITEM')
export const COMPLETE_CAPTURE_ITEM = defineAction('COMPLETE_CAPTURE_ITEM')

export const createCaptureItem = payload => (dispatch, getState) =>
  dispatch({
    type: CREATE_CAPTURE_ITEM.ACTION,
    payload: captureItemsService
      .createCaptureItem(getState().user.get('token'))(payload)
      .then(() => captureItemsService.getCaptureItems(getState().user.get('token'))),
  })

export const getCaptureItems = () => (dispatch, getState) =>
  dispatch({
    type: GET_CAPTURE_ITEMS.ACTION,
    payload: captureItemsService.getCaptureItems(getState().user.get('token')),
  })

export const editCaptureItem = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_CAPTURE_ITEM.ACTION,
    payload: captureItemsService
      .updateCaptureItem(getState().user.get('token'))(payload)
      .then(() => captureItemsService.getCaptureItems(getState().user.get('token'))),
  })

export const updateCaptureItemDate = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_CAPTURE_ITEM_DATE.ACTION,
    payload: captureItemsService
      .updateCaptureItemDate(getState().user.get('token'))(payload)
      .then(() => captureItemsService.getCaptureItems(getState().user.get('token'))),
  })

export const updateCaptureItemStatus = payload => (dispatch, getState) =>
  dispatch({
    type: UPDATE_CAPTURE_ITEM_STATUS.ACTION,
    payload: captureItemsService
      .updateCaptureItemStatus(getState().user.get('token'))(payload)
      .then(() => captureItemsService.getCaptureItems(getState().user.get('token'))),
  })

export const deleteCaptureItem = payload => (dispatch, getState) =>
  dispatch({
    type: DELETE_CAPTURE_ITEM.ACTION,
    payload: captureItemsService
      .deleteCaptureItem(getState().user.get('token'))(payload)
      .then(() => payload.itemId),
  })

export const setCaptureItemsOrder = payload => (dispatch, getState) =>
  dispatch({
    type: SET_CAPTURE_ITEMS_ORDER.ACTION,
    payload: captureItemsService
      .setCaptureItemsOrder(getState().user.get('token'))(payload)
      .then(() => captureItemsService.getCaptureItems(getState().user.get('token'))),
  })

export const completeCaptureItem = payload => (dispatch, getState) =>
  dispatch({
    type: COMPLETE_CAPTURE_ITEM.ACTION,
    payload: captureItemsService
      .completeCaptureItem(getState().user.get('token'))(payload)
      .then(() => captureItemsService.getCaptureItems(getState().user.get('token'))),
  })



// WEBPACK FOOTER //
// ./src/modules/capture-items/actions.js